import { createElement } from 'react'

type AwellTextDefinition = {
  type: 'p' | string
  children: { text: string }[]
}

type AwellTextProps = {
  definition: AwellTextDefinition
}

const AwellText = ({ definition }: AwellTextProps) => {
  return createElement(
    definition.type,
    null,
    definition.children.map((child) => child.text),
  )
}

export type { AwellTextDefinition, AwellTextProps }
export { AwellText }
